import { Row, Drawer } from "antd";
import ProductPanelSM from "../../../components/PointOfSale/Retail/productPanelSM";
import GroupedProducts from "../../../lib/components/GroupedProducts";
import RetailModals from "../../PointOfSale/Retail/RetailModals";
import QuantityUpdate from "../../PointOfSale/Retail/QuantityUpdate";

const BottomPanels = ({
  // Product Panel Drawer props
  isProductsVisible,
  closeProductPanel,
  isQtyUpdate,
  setIsQtyUpdate,
  checkIsManualWeight,
  setIsSearchProducts,
  getMoreProducts,
  productItems,
  setProductItems,
  selectProductInCart,
  setProductArray,
  isProductsFilter,
  getSearchedProducts,
  productListCardRef,
  productsDisplay,
  setIsProductsVisible,
  pickProduct,
  filterDrawer,
  setFilterDrawer,
  productSearchInput,
  setProductSearchInput,
  setOpen,
  keyboardType,
  setKeyboardType,
  productSearchInputRef,
  clearProductSearchResults,
  productsData,
  productSearchRef,
  handleSelectProduct,
  productsList,
  setProductsList,
  setLayoutName,
  productPanelSearchRef,
  setInputName,
  keyboard,
  searchInputRef,
  stockList,
  setStockList,
  selectedProductInCart,
  setCart,
  // QuantityUpdate props
  addProduct,
  increaseProductQty,
  decreaseProductQty,
  removeProductModal,
  // GroupedProducts props
  showCustomMix,
  setShowCustomMix,
  cart,
  customMixItems,
  setCustomMixItems,
  groupName,
  setGroupName,
  groupQty,
  setGroupQty,
  existingGroupItems,
  setExistingGroupItems,
  selectedCustomMix,
  setSelectedCustomMix,
  orderType,
  setOrderType,
  posSaleTypes,
  setPosSaleTypes,
  currenciesData,
  setCurrenciesData,
  setActiveInput,
  setProductStock,
  showPreviousItems,
  showMoreItems,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
  processBillDiscounts,
  setLoader,
  processTotalManualDiscount,
  // RetailModals
  allProps,
}) => {
  const productPanelProps = {
    checkIsManualWeight,
    setIsSearchProducts,
    getMoreProducts,
    productItems,
    setProductItems,
    selectProductInCart,
    setProductArray,
    isProductsFilter,
    getSearchedProducts,
    productListCardRef,
    productsDisplay,
    setIsProductsVisible,
    pickProduct,
    filterDrawer,
    setFilterDrawer,
    productSearchInput,
    setProductSearchInput,
    setOpen,
    keyboardType,
    setKeyboardType,
    productSearchInputRef,
    clearProductSearchResults,
    productsData,
    productSearchRef,
    handleSelectProduct,
    productsList,
    setProductsList,
    setLayoutName,
    productPanelSearchRef,
    setInputName,
    keyboard,
    searchInputRef,
    stockList,
    setStockList,
    selectedProductInCart,
    setCart,
  };

  return (
    <>
      {/* ——— PRODUCT PANEL DRAWER ——— */}
      <Drawer
        placement="bottom"
        height="75vh"
        title={null}
        closeIcon={null}
        className="filter"
        styles={{ header: { height: 0 } }}
        styles={{ body: { paddingTop: 0 } }}
        open={isProductsVisible}
        closable={true}
        onClose={closeProductPanel}
        footer={null}
      >
        <Row
          style={{
            paddingTop: isQtyUpdate ? 0 : "1.7%",
            width: "100%",
            paddingLeft: "1vw",
          }}
        >
          <ProductPanelSM
            {...productPanelProps}
            isProductsVisible={isProductsVisible}
          />
        </Row>
      </Drawer>

      {isQtyUpdate ? (
        <QuantityUpdate
          selectedProductInCart={selectedProductInCart}
          addProduct={addProduct}
          setIsQtyUpdate={setIsQtyUpdate}
          isQtyUpdate={isQtyUpdate}
          increaseProductQty={increaseProductQty}
          decreaseProductQty={decreaseProductQty}
          removeProductModal={removeProductModal}
          setIsSearchProducts={setIsSearchProducts}
        />
      ) : (
        ""
      )}

      <ProductPanelSM {...productPanelProps} />

      <GroupedProducts
        showCustomMix={showCustomMix}
        setShowCustomMix={setShowCustomMix}
        cart={cart}
        setCart={setCart}
        customMixItems={customMixItems}
        setCustomMixItems={setCustomMixItems}
        groupName={groupName}
        setGroupName={setGroupName}
        groupQty={groupQty}
        setGroupQty={setGroupQty}
        existingGroupItems={existingGroupItems}
        setExistingGroupItems={setExistingGroupItems}
        selectedCustomMix={selectedCustomMix}
        setSelectedCustomMix={setSelectedCustomMix}
        orderType={orderType}
        setOrderType={setOrderType}
        posSaleTypes={posSaleTypes}
        setPosSaleTypes={setPosSaleTypes}
        currenciesData={currenciesData}
        setCurrenciesData={setCurrenciesData}
        searchInputRef={searchInputRef}
        setActiveInput={setActiveInput}
        setProductStock={setProductStock}
        showPreviousItems={showPreviousItems}
        showMoreItems={showMoreItems}
        setShowCompleteSaleStock={setShowCompleteSaleStock}
        setCompleteSaleStockData={setCompleteSaleStockData}
        processBillDiscounts={processBillDiscounts}
        setLoader={setLoader}
        processTotalManualDiscount={processTotalManualDiscount}
      />
      <RetailModals {...allProps} />
    </>
  );
};

export default BottomPanels;
